import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";
import { cn, getTrueDate } from "@/lib/utils";
import { useAtomValue } from "jotai";
import { useEffect, useRef } from "react";

type EventInfoContainerProps = {
  eventsList: { name: string, id: number }[],
  selected: string,
  setSelected: (id: string) => void;
  date: {
    start_date: string,
    end_date: string,
  }
}

const EventInfoContainer = ({ eventsList, selected, setSelected, date }: EventInfoContainerProps) => {

  const themeClass = useAtomValue(themeAtom)

  const nameContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (selected && nameContainerRef.current) {
      const selectedElement = document.getElementById(selected.replace(/\s+/g, '-'))
      if (selectedElement) {
        const { offsetTop, offsetHeight } = selectedElement as HTMLElement;
        const container = nameContainerRef.current;

        const scrollTop =
          offsetTop - container.clientHeight / 2 + offsetHeight / 2;

        container.scrollTo({
          top: scrollTop,
          behavior: "smooth",
        });
      }
    }
  }, [selected]);

  return (
    <div id="event-names" className="md:fixed top-[10%] right-7 md:w-[28%] lg:w-[22%] flex-col justify-between items-start flex p-3 h-full md:h-[88vh]">
      <div className="flex flex-col gap-2 max-h-[80%] overflow-hidden">
        <span className="py-2 text-2xl font-semibold font-montserrat">Campaign Ideas</span>
        <div className="flex flex-col gap-3 flex-1 overflow-y-scroll [&::-webkit-scrollbar]:w-2" ref={nameContainerRef}>
          {eventsList.map(event =>
            <p id={event.name.replace(/\s+/g, "-")}
              onClick={() => setSelected(event.name)}
              className={cn(
                "font-poppins tracking-wide ps-2 cursor-pointer transition-all ease-in-out duration-700",
                selected === event.name ? "text-base text-theme-primary font-semibold" : "text-xs"
              )}
              style={{ color: selected === event.name ? themeClass.primary : "" }}
              key={event.id}>
              {event.name}
            </p>
          )}
        </div>
      </div>
      <div className="border border-gray-100 gap-2 py-5 px-4 w-full shadow-md h-fit rounded-lg flex flex-col">
        <p className="text-lg font-montserrat font-medium">{selected}</p>
        <p className="font-semibold font-poppins text-sm">Start Date : {getTrueDate(date.start_date, "MMM dd")}</p>
        <p className="font-semibold font-poppins text-sm">End Date : {getTrueDate(date.end_date, "MMM dd")}</p>
      </div>
    </div>
  )
}

export default EventInfoContainer;
